var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100vh - 246px)"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xxl-4"},[_c('ListWidget9')],1),_c('div',{staticClass:"col-xxl-4 order-1 order-xxl-1"},[_c('ListWidget1')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }